export const initButtons = () => {
	// Ripple effect
	const rippleButtons = document.querySelectorAll("button, .fancy-btn, .ripple-btn, .cta a, blueprint-btn button");
	for (const button of rippleButtons) {
		button.addEventListener("click", createRipple);
	}

	// Page turn effect
	const pageTurnButtons = document.querySelectorAll(".page-turn-btn");
	for (const button of pageTurnButtons) {
		button.addEventListener("click", createPageTurn);
	}

	initThreeDPanel();
};

const createRipple = (event) => {
	const button = event.currentTarget;
	const circle = document.createElement("span");
	const elementWidth = button.clientWidth != 0 ? button.clientWidth : button.offsetWidth;
	const elementHeight = button.clientHeight != 0 ? button.clientHeight : button.offsetHeight;
	const diameter = Math.max(elementWidth, elementHeight);

	const radius = diameter / 2;
	const buttonLeftPositionRelativeToViewport = button.getBoundingClientRect().left;
	const buttonTopPositionRelativeToViewport = button.getBoundingClientRect().top;

	circle.style.width = circle.style.height = `${diameter}px`;
	circle.style.left = `${event.clientX - buttonLeftPositionRelativeToViewport - radius}px`;
	circle.style.top = `${event.clientY - buttonTopPositionRelativeToViewport - radius}px`;
	circle.classList.add("ripple");

	const ripple = button.getElementsByClassName("ripple")[0];

	if (ripple) {
		ripple.remove();
	}

	button.appendChild(circle);
};

const createPageTurn = (event) => {
	const button = event.currentTarget;

	// remove active-page-turn class from all buttons
	const buttons = document.querySelectorAll(".page-turn-btn");
	for (const button of buttons) {
		button.classList.remove("active-page-turn");
	}

	// add active-page-turn class to current button
	button.classList.add("active-page-turn");
};

const initThreeDPanel = () => {
	const popupPanels = document.querySelectorAll(".threed-panel");
	popupPanels.forEach((panel) => {
		let ax = 0;
		let ay = 0;

		panel.addEventListener("mousemove", function (e) {
			const rect = panel.getBoundingClientRect();
			const x = e.clientX - rect.left;
			const y = e.clientY - rect.top;
			const xc = rect.width / 2;
			const yc = rect.height / 2;
			const dx = (x - xc) / rect.width; // Normalize by width
			const dy = (y - yc) / rect.height; // Normalize by height

			// Adjust intensity based on panel size
			const baseIntensity = 20; // Base intensity for rotation
			const sizeFactor = 300; // Reference size for intensity calculation
			const intensity = baseIntensity * (sizeFactor / Math.max(rect.width, rect.height));

			ax = -dy * intensity;
			ay = dx * intensity;

			// Calculate the distance from the center and adjust scale
			const distance = Math.sqrt(Math.pow(dx, 2) + Math.pow(dy, 2));
			const scale = 1 - (1 - distance) * 0.05; // Up to 5% scale down as mouse approaches the center

			panel.style.transform = `perspective(1000px) rotateX(${ax}deg) rotateY(${ay}deg) scale(${scale})`;
		});
		panel.addEventListener("mouseleave", function () {
			panel.style.transform = `perspective(1000px) rotateX(0deg) rotateY(0deg) scale(1)`;
		});
		panel.addEventListener("mousedown", function () {
			// Increase the rotation angles to simulate a "knock-back" effect
			const knockBackFactor = 2;
			const knockBackX = ax * knockBackFactor;
			const knockBackY = ay * knockBackFactor;

			// Scale down more on click
			const scaleDownOnClick = 0.9; // 10% scale down on click

			panel.style.transform = `perspective(1000px) rotateX(${knockBackX}deg) rotateY(${knockBackY}deg) scale(${scaleDownOnClick})`;

			setTimeout(() => {
				panel.style.transform = `perspective(1000px) rotateX(${ax}deg) rotateY(${ay}deg) scale(1)`;
			}, 150);
		});
	});
};
